import React, { useState } from "react";
import { AddToolTip, FormControlSearch } from "../../../components";
import { Card, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import {
  passthroughStringToFunctionConverter,
  removePassthroughFieldTrans,
} from "../../../utils";

const PassthroughTargetDroppedContainer = (props) => {
  const {
    onDeleteMapping,
    data,
    mappedObject,
    setFieldOrder,
    setShowSlideOut,
    setFieldIndex,
    index,
    masterSourceDate,
  } = props;
  return (
    <>
      <Card
        className={"cardCss"}
        style={{ background: "#F7F7F7", width: "18.125rem" }}
      >
        <div className="fieldTitle">
          <span className="fieldText w-70">
            {data?.isNewField ? (
              <AddToolTip
                name={passthroughStringToFunctionConverter(
                  removePassthroughFieldTrans(data.fieldName),
                  masterSourceDate,
                  0
                )?.toString()}
              />
            ) : (
              <AddToolTip
                name={passthroughStringToFunctionConverter(
                  removePassthroughFieldTrans(data.value),
                  masterSourceDate,
                  0
                )?.toString()}
              />
            )}
          </span>
        </div>
        <div className="columnTitle mt-2">
          <span
            className="columnText"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setShowSlideOut(true);
              setFieldIndex(index);
              setFieldOrder(data.order);
            }}
          >
            <FontAwesomeIcon icon={faCog} color="#4F4F4F" />
          </span>
          <hr className="vertical-separator mt-3"></hr>
          <span className="columnText">
            <FontAwesomeIcon
              style={{ cursor: "pointer" }}
              onClick={() => onDeleteMapping(data.order)}
              icon={faTrashAlt}
              size="25px"
              color="#EB5757"
              // className="payroll-delete"
            />
          </span>
        </div>
        <div className="sampleData">
          <span className="sampleDataText">
            Value :{" "}
            <span className="sampleValueText">
              {passthroughStringToFunctionConverter(
                removePassthroughFieldTrans(data.value),
                masterSourceDate,
                1
              )?.toString()}
            </span>
          </span>
        </div>
        {/* <div className="dataType"></div> */}
      </Card>
    </>
  );
};

export default PassthroughTargetDroppedContainer;
